import axiosInstance from '../axios.config';
import { getUserToken } from '../utils/user.utils';


export const getCourseSteps = (courseId) => {
    return axiosInstance.get(`/CourseStep/Course/${courseId}`)
}

export const getCourseStepsProgressForUser = (courseId, userId) => {
    return axiosInstance.get(`/UserCourseStep/ByCourseAndUser/${courseId}/${userId}`)
}

export const getCourseStepsProgressForUser_Safe = async (sortedCourseSteps, courseId, userId) => {
    let userProgressData = await getCourseStepsProgressForUser(courseId, userId);
    let userProgress = userProgressData.data;
    // if no progress for user create rows
    if (userProgress.length === 0) {
        createUserCourse(courseId, userId);
        const newUserProgress = sortedCourseSteps.map((step) => ({
            courseStepID: 0,
            userID: userId,
            courseID: courseId,
            stepNumber: step.stepNo,
            status: "InComplete",
        }));
        await createUserCourseSteps(newUserProgress);
        const newUserProgressRes = await getCourseStepsProgressForUser(courseId, userId)
        return newUserProgressRes.data
    } else {
        return userProgress
    }
}

export const createUserCourse = (courseId, userId) => {
    const userCourseData = {
        UserID: userId,
        CourseID: courseId,
        IsCourseCompleted: false,
        StartTime: new Date(),
        EndTime: new Date(),
        Rating: null,
        Comments: "No comment from user",
    };
    return axiosInstance.post(`/UserCourse`, userCourseData);
}

export const createUserCourseSteps = async (userSteps) => {
    for (const Step of userSteps) {
        await axiosInstance.post(`/UserCourseStep`, Step);
    }
}

export const getCourseStepHtmlContent = async (courseStep) => {
    if (courseStep.description && courseStep.description.endsWith('.html')) {
        const res = await getFileContent(courseStep.courseID, courseStep.stepNo, 'HTML', courseStep.description, 'text');
        if (res?.data) {
            return { type: 'html', content: res.data };
        }
        // Fallback if file not found
        return { type: 'html', content: '<p>Content not available</p>' };
    }
    return { type: 'html', content: courseStep.description || '' };
};

export const getCourseStepVideoContent = async (courseStep) => {
    if (!courseStep.stepContent) {
        return { type: 'video', content: null };
    }

    // Get direct Azure streaming URL with SAS token for fast loading
    // This bypasses API proxying and streams directly from Azure
    try {
        const response = await axiosInstance.get(`/CourseStep/streamurl`, {
            params: {
                CourseID: courseStep.courseID,
                StepNo: courseStep.stepNo,
                ContentType: courseStep.contentType,
                FileName: courseStep.stepContent
            }
        });
        
        if (response?.data?.url) {
            return { type: 'video', content: response.data.url };
        }
        
        console.error('No streaming URL received from server');
        return { type: 'video', content: null };
    } catch (error) {
        console.error('Error getting video streaming URL:', error);
        return { type: 'video', content: null };
    }
};

export const getCourseStepImagesContent = async (courseStep) => {
    const fileNames = courseStep.stepContent?.split(',') || [];
    if (fileNames.length === 0) {
        return { type: 'images', content: [] };
    }
    
    // StepContent can be comma-separated filenames or URLs (backward compatibility)
    // Use API endpoint to proxy from Azure (avoids CORS)
    const responses = await Promise.all(
        fileNames.map(async (fileName) => {
            const trimmedFileName = fileName.trim();
            if (!trimmedFileName) return null;
            
            const res = await getFileContent(courseStep.courseID, courseStep.stepNo, courseStep.contentType, trimmedFileName, 'arraybuffer');
            if (res?.data) {
                const blob = new Blob([res.data], { type: 'image/jpeg' });
                return URL.createObjectURL(blob);
            }
            return null;
        })
    );
    
    return { type: 'images', content: responses.filter(url => url !== null) };
};

export const getBgImageContentUrl = async (courseStep) => {
    const bgImgFileName = courseStep.stepBgImgFileName;
    if (!bgImgFileName) return { type: 'bgImg', content: "" };
    
    // StepBgImgFileName can be either a filename or full URL (backward compatibility)
    // Use API endpoint to proxy from Azure (avoids CORS)
    const res = await getFileContent(courseStep.courseID, courseStep.stepNo, "Image", bgImgFileName, 'arraybuffer');
    if (res?.data) {
        const blob = new Blob([res.data], { type: 'image/jpeg' });
        return { type: 'bgImg', content: URL.createObjectURL(blob) };
    }
    
    return { type: 'bgImg', content: "" };
};

export const getFileContent = async (courseID, stepNo, contentType, fileName, responseType = 'text') => {
    try {
        const response = await axiosInstance.get(
            `/CourseStep/filecontent?CourseID=${courseID}&StepNo=${stepNo}&ContentType=${contentType}&FileName=${fileName}`,
            { responseType }
        );
        return response;
    } catch (error) {
        console.warn(`Failed to load file: ${fileName}`, error?.response?.status || error.message);
        return null;
    }
};

export const updateUserProgressOnCourse = async (courseId, userId, stepNo) => {
    return  axiosInstance.put(`/UserCourseStep/UpdateStatus`, null, {
        params: {
            courseId: courseId,
            userId: userId,
            stepNumber: stepNo,
            status: "Completed",
        },
    });
};

export const deleteStepMedia = async (courseID, stepNo, contentType, fileName) => {
    return axiosInstance.delete(`/CourseStep/DeleteStepMedia`, {
        params: {
            CourseID: courseID,
            StepNo: stepNo,
            ContentType: contentType,
            FileName: fileName
        }
    });
};